import React, { useEffect, useState } from "react";
import { typography, textColors } from "../../design-system/tokens";
import SubscriptionConfigCard from "../components/SubscriptionConfigCard";

const useMatchMedia = (query, defaultValue = false) => {
  const [matches, setMatches] = useState(() => {
    try {
      if (typeof window === "undefined" || typeof window.matchMedia !== "function") return !!defaultValue;
      return !!window.matchMedia(query).matches;
    } catch {
      return !!defaultValue;
    }
  });

  useEffect(() => {
    try {
      if (typeof window === "undefined" || typeof window.matchMedia !== "function") return undefined;
      const mql = window.matchMedia(query);

      const handler = (e) => setMatches(!!e.matches);
      // Ensure state is in sync on mount (query may have changed).
      setMatches(!!mql.matches);

      if (typeof mql.addEventListener === "function") {
        mql.addEventListener("change", handler);
        return () => mql.removeEventListener("change", handler);
      }

      // Safari / older browsers.
      if (typeof mql.addListener === "function") {
        mql.addListener(handler);
        return () => mql.removeListener(handler);
      }
    } catch {
      // ignore
    }
    return undefined;
  }, [query]);

  return matches;
};

const SubscriptionConfigAdminPage = () => {
  const isMobile = useMatchMedia("(max-width: 767px)", false);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div>
        <h2 className={`${typography.h3} ${textColors.primary}`}>Subscriptions</h2>
        <p className={`${typography.body} ${textColors.secondary}`}>
          Platform-wide settings that control whether users can start or change paid subscriptions.
        </p>
      </div>

      <div className="mt-6">
        <SubscriptionConfigCard isMobile={isMobile} />
      </div>
    </div>
  );
};

export default SubscriptionConfigAdminPage;

